export const initialState = {
  skincare: {
    collectionsWomen: [],
    collectionsMen: [],
  },
  fragrances: {
    collectionsWomen: [],
    collectionsMen: [],
  },
}
